import React from 'react';
import { connect } from 'react-redux';
import { userUpdate } from '@/store/actions/user/actions';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import styles from './Login.module.css';
import Button from '@/components/common/Button';
import Logo from './img/logo_login.png';
import { apiLogin, apiGetUser, extractData } from '@/api';
import { setObjectInLS } from '@/util/localstorage';

const Login = props => {
  const { userUpdate } = props;
  const history = useHistory();

  return (
    <div className={ styles.Login }>
      <div className={ styles.LoginContent }>
        <img src={ Logo } />
        <div className={ styles.LoginForm }>
          <Formik
            enableReinitialize
            initialValues={{
              account: '',
              password: ''
            }}
            onSubmit={(values, actions) => {
              apiLogin(values).then(res => {
                const data = extractData(res);
                const user = {
                  account: values.account,
                  token: data.access_token
                };
                setObjectInLS('user', user);
                userUpdate(user);
                history.push('/');
              });
              actions.setSubmitting(false);
            }}
          >
            {formikProps => (
              <form
                className={ styles.SongsEditForm }
                onSubmit={ formikProps.handleSubmit }
              >
                <div className={ styles.FormInput }>
                  <input
                    id='account'
                    name='account'
                    placeholder='account'
                    value={ formikProps.values.account }
                    onChange={ formikProps.handleChange }
                  />
                  <FontAwesomeIcon
                    icon={ fas.faUser }
                    size={ '1x' }
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '0',
                      transform: 'translate(-60%, -50%)'
                    }}
                  />
                </div>
                <div className={ styles.FormInput }>
                  <input
                    id='password'
                    name='password'
                    type='password'
                    placeholder='password'
                    value={ formikProps.values.password }
                    onChange={ formikProps.handleChange }
                  />
                  <FontAwesomeIcon
                    icon={ fas.faLock }
                    size={ '1x' }
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '0',
                      transform: 'translate(-60%, -50%)'
                    }}
                  />
                </div>
                <div className={ styles.StatusCheck }>
                  <input
                    id='remeber'
                    type='checkbox'
                  />
                  <label htmlFor='remeber'>
                    ログイン状態を保持する
                  </label>
                </div>
                <Button
                  arrow={ false }
                  color='Grey'
                  text='ログイン'
                  size='Long'
                  margin='2rem auto'
                  width='90%'
                  type='submit'
                />
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ user }, owns) => ({
  user,
  ...owns
})

const mapDispatchToProps = dispatch => ({
  userUpdate: values => dispatch(userUpdate(values))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
